(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/fraction-payment/assets/javascripts/show-payment-dialog.js') >= 0) return;  svs.modules.push('/components/marketplace/fraction-payment/assets/javascripts/show-payment-dialog.js');
"use strict";

const {
  payFractions
} = svs.components.marketplaceData.fractionPayment.actions;
const {
  showDialog
} = svs.components.marketplaceData.dialogWrapper.actions;

const getDialogOptions = (fractionPrice, termsUrl, callback, obligatoryCallback) => {
  const title = 'Betala';
  const text = "Vill du betala ".concat(fractionPrice, " kr f\xF6r 1 andel i spelet? <br /><br />Om spelet inte l\xE4mnas in eller om det avbryts f\xE5r du pengarna tillbaka.<br /><br />Genom att k\xF6pa en andel godk\xE4nner du <a href=\"").concat(termsUrl, "\" rel=\"noopener noreferrer\" target=\"_BLANK\">Villkor f\xF6r att Spela tillsammans</a>.");
  const buttons = [{
    text: 'Avbryt',
    classes: {
      inverted: true
    },
    callback: () => {
      obligatoryCallback();
    }
  }, {
    text: 'Betala',
    classes: {
      focus: true
    },
    callback: () => {
      obligatoryCallback();
      callback();
    },
    showLoader: true
  }];
  return {
    title,
    text,
    buttons,
    icon: 'games'
  };
};

const showPaymentDialog = (dispatch, setDisabledBuyButton, fractionPrice, termsUrl, groupId, activatedDrawId, isRetail, hasJoinTeam, invitationToken) => {
  const obligatoryCallback = () => {
    setDisabledBuyButton(false);
  };
  const handleDialogPayClick = () => {
    dispatch(payFractions(groupId, activatedDrawId, isRetail, hasJoinTeam, invitationToken));
  };
  dispatch(showDialog(getDialogOptions(fractionPrice, termsUrl, handleDialogPayClick, obligatoryCallback)));
};

setGlobal('svs.components.marketplace.fractionPayment.showPaymentDialog', showPaymentDialog);

 })(window);